import React, { useMemo } from 'react'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { Button, PageHeader, Pill } from '@demandlocal/components'
import { useGetDealerProfileLayout } from '../../../../api/dealership/profile/useGetProfileLayout'
import loadable from '@loadable/component'
import LoadingAnimation from '../../../../components/LoadingAnimation'
import { useGetUser } from '../../../../api/auth/useGetUser'
import { Route, Routes, useNavigate } from 'react-router'
import AddCustomersForm from '../../../../forms/AddCustomers'
import AddAudience from '../../../../forms/AddAudience'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

const ProfileComponents = {
  1: loadable(() => import('./ProfileComponents/UnmappedDealerProfile')),
  2: loadable(() => import('./ProfileComponents/ReturningDealerProfile')),
  3: loadable(() => import('./ProfileComponents/DealerProfileWithDMS')),
  4: loadable(() => import('./ProfileComponents/PolkDealerProfile')),
  5: loadable(() => import('./ProfileComponents/RetailProfile')),
  6: loadable(() => import('./ProfileComponents/SelfServiceProfile')),
  7: loadable(() => import('./ProfileComponents/SetupProfile')),
  8: loadable(() => import('./ProfileComponents/PerformanceProfile')),
}

export default function DealerProfile(): JSX.Element {
  const dealership = useDealership()
  const { data: profileLayout, isLoading: isLoadingProfile } = useGetDealerProfileLayout()

  const Component = useMemo(() => {
    return ProfileComponents[profileLayout?.profile_type ?? 1]
  }, [profileLayout?.profile_type])

  const user = useGetUser()
  const navigate = useNavigate()
  const { t } = useTranslation('routes')

  return (
    <div className={'flex min-h-screen flex-1 flex-col pb-4'}>
      <PageHeader
        cardsOptions={[]}
        title={dealership?.dealership}
        link={dealership?.url}
        rightSlot={(hidden) => (
          <div>
            {
              <div className="flex flex-row gap-2 pl-3">
                {profileLayout?.profile_type === 3 && (
                  <Button
                    variant="rainbow"
                    onClick={(e) => {
                      e.preventDefault()
                      navigate(t('dealership.reports.summary', { dealership }))
                    }}>
                    <div className="flex flex-row gap-3 items-center">
                      <Pill type="gray">NEW</Pill>
                      <span>View Last Months Campaigns</span>
                    </div>
                  </Button>
                )}
                {user.data?.role_id === 1 ? (
                  <Button
                    customStyles="ml-2"
                    variant="secondary"
                    onClick={() =>
                      navigate(
                        `/dashboard/admin/dealerships/${dealership?._id}/edit/details`,
                      )
                    }>
                    Edit
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            }
          </div>
        )}
      />
      <div
        className={classNames('flex flex-1 h-full justify-start', {
          'items-center': isLoadingProfile,
        })}>
        {isLoadingProfile ? (
          <div className="flex flex-1 h-full items-center justify-center">
            <LoadingAnimation title="Loading Organization" />
          </div>
        ) : (
          <Routes>
            <Route path="*" element={<Component />}>
              <Route
                path="sources/new/*"
                element={<AddCustomersForm />}
                key="add_customers_route"
              />
              <Route
                path="audience/new/*"
                element={<AddAudience />}
                key="add_audience_route"
              />
            </Route>
          </Routes>
        )}
      </div>
    </div>
  )
}
